import React, { useEffect, useState } from 'react'
import styles from './styles.jcss'
import { api } from '../../../../core/api/ConnectionManager'
import translate from '../../../../core/translate'
import { FileDetailsProps, FileDetailsSource } from './FileDetails-types'

export const FileDetails = ({ sourceId }: FileDetailsProps) => {
    const [source, setSource] = useState<FileDetailsSource | null>(null)

    useEffect(() => {
        if (!sourceId) return

        api.send('getFile', { id: sourceId }).then((res) => {
            setSource(res as FileDetailsSource)
        })
    }, [sourceId])

    return (
        <div className={styles.fileDetails}>
            {source ? (
                <>
                    <div className={styles.thumbnail}>
                        <img src={source.thumbnail} alt={source.name} />
                    </div>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <b>{translate('name')}:</b>
                                </td>
                                <td>{source.name.replace(/\.[^/.]+$/, '')}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>{translate('type')}:</b>
                                </td>
                                <td>{translate(source.fileType)}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>{translate('format')}:</b>
                                </td>
                                <td>{source.extension.replace(/\./g, '')}</td>
                            </tr>
                        </tbody>
                    </table>
                </>
            ) : null}
        </div>
    )
}
